import { render } from "./RequestForQuote.vue?vue&type=template&id=ffa56680&scoped=true"
import script from "./RequestForQuote.vue?vue&type=script&lang=js"
export * from "./RequestForQuote.vue?vue&type=script&lang=js"

import "./RequestForQuote.vue?vue&type=style&index=0&id=ffa56680&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa56680"]])

export default __exports__